import ufeApi from 'services/api/ufeApi';
import cookieUtils from 'utils/Cookies';

// https://jira.sephora.com/browse/CE-286

function submitEmailSMSOptInForm(payload) {
    let url = '/api/util/OptinEmailSms';
    const { enableProfileAccountGroup = false } = Sephora.configurationSettings;

    if (enableProfileAccountGroup && cookieUtils.isRCPAccountAPIEnabled()) {
        url = '/gway/v2/util/OptinEmailSms';
    }

    return ufeApi
        .makeRequest(url, {
            method: 'POST',
            body: JSON.stringify(payload)
        })
        .then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default { submitEmailSMSOptInForm };
